import React, { useState } from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Link,
  Row
} from 'react-bootstrap';

import Login from '../components/Login';

import '../App.css';

export default function Home() {
  const [token, setToken] = useState();
  
  return (
    <>
      <h1 className="px-3 text-sm-start text-md-center">Ratings and reviews on autopilot</h1>
      <Login setToken={setToken} />
      <Container fluid className="my-5">
        <Row>
          <Col></Col>
          <Col sm={6}>
            <h5>To learn more, visit us at <Card.Link href="https://repcaster.com">RepCaster.com</Card.Link></h5>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  );
}